import layout from '@/layout'

export default {
  path: '/tenant',
  component: layout,
  redirect: '/tenant/user',
  name: 'clinicManage',
  meta: {
    title: '租户管理',
    icon: 'hospital'
  },
  children: [
    {
      path: '/tenant/user',
      component: () => import('@/views/tenantManage/tenant-user'),
      meta: {
        title: '租户用户信息',
        icon: 'user'
      }
    }
  ]
}
